<template>
  <div class="logo">
    <router-link :to="{ name: 'home' }" class="logo__link">
      <div class="logo__img">
        <img src="@/assets/images/logo.png" alt="空英老師專區">
      </div>
      <div class="logo__title">
        空英老師專區
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'logo'
}
</script>
